module.exports = __webpack_public_path__ + "static/french_horn_cn-76aaccd859060b4b57ac1df0333b7d18.pdf";